import React, { useState, useEffect, useRef } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MdLocationPin } from "react-icons/md";
import { IoMdTime } from "react-icons/io";
import Style from '../Styles/Common.module.css';
import Button from '../Styles/Button.module.css';
import { Link, useLocation } from "react-router-dom";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import { getEventsListFormData } from "../../services/routes.services";
import constants from "../../services/constants";
import dateFormat from 'dateformat';
import { useSelector } from 'react-redux';
import parse from 'html-react-parser';
import { GrFormNextLink, GrFormPreviousLink  } from "react-icons/gr";
import BreadcrumbComponent from "../Common/CommonSections/Breadcrum";

const EventComponent = () => {
    const navigat = useLocation();
    const [getAllData, setGetAllData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [years, setYears] = useState([]);
    const [cities, setCities] = useState([]);
    const { isAuthenticated, user, token } = useSelector((state) => state.auth);
      // Pagination state
      const [currentPage, setCurrentPage] = useState(1);
      const currentPath = navigat.pathname;
      const itemsPerPage = currentPath === "/" ? 3 : 12;
    const sectionPageingScroll = useRef(null);
    const scrollToSection = (ref) => {
        if (ref && ref.current) {
          ref.current.scrollIntoView({ behavior: "smooth" });
        } else {
          console.error("Ref is not attached to a DOM element");
        }
      };

    useEffect(() => {
        getEventsListFormData()
            .then((res) => {
                const events = res.data.events;
                setGetAllData(events);
                setFilteredData(events);
                extractDropdownValues(events);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const extractDropdownValues = (events) => {
        const uniqueYears = [...new Set(events.map(event => new Date(event.eventDate).getFullYear()))];
        const sortedYear = [...uniqueYears].map(Number).sort((a, b) => a - b);
        const uniqueCities = [...new Set(events.map(event => event.city))];
        setYears(sortedYear);
        setCities(uniqueCities);
    };

    const smoothScroll = () => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    };

    const handleSearch = () => {
        const filtered = getAllData.filter(event => {
            const matchesSearch = event.title.toLowerCase().includes(searchQuery.toLowerCase());
            const matchesYear = selectedYear ? new Date(event.eventDate).getFullYear().toString() === selectedYear : true;
            const matchesCity = selectedCity 
            ? event.city && event.city.name === selectedCity 
            : true;
            return matchesSearch && matchesYear && matchesCity;
        });
        setFilteredData(filtered);
        setCurrentPage(1);
    };

    useEffect(() => {
        handleSearch();
    }, [searchQuery, selectedYear, selectedCity]);


    const currentDate = new Date();
    let lastElement = null;
    let futureEventsData = [];
    let isAfterTargetDate = false;
if (filteredData.length > 0) {
    const futureEvents = filteredData.filter(event => new Date(event.eventDate) > currentDate);
    if (futureEvents.length > 0) {
        lastElement = futureEvents[0];
        futureEventsData = futureEvents;
        const targetDate = new Date(lastElement.endDate);
        isAfterTargetDate = currentDate > targetDate;
    }
}
let postEventData = [];
if (filteredData.length > 0) {
    const futureEvents = filteredData.filter(event => new Date(event.eventDate) < currentDate);
    if (futureEvents.length > 0) {
        postEventData = futureEvents;
    }
}

// Pagination logic
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentItems = postEventData.slice(indexOfFirstItem, indexOfLastItem);
console.log(postEventData)
const totalPages = Math.ceil(postEventData.length / itemsPerPage);

const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    scrollToSection(sectionPageingScroll);
}
const goToFirstPage = () => {
    scrollToSection(sectionPageingScroll);
    setCurrentPage(1);
}
const goToLastPage = () => {
    setCurrentPage(totalPages);
    scrollToSection(sectionPageingScroll);
}
const goToPreviousPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
    scrollToSection(sectionPageingScroll);
};

const goToNextPage = () => {
    scrollToSection(sectionPageingScroll);
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
   
};
// Step 1: Filter out undefined and incomplete entries
const validCities = cities.filter(city => city && city.name);

// Step 2: Remove duplicates by using a Set
const uniqueCities = Array.from(new Map(validCities.map(city => [city.name, city])).values());

// Step 3: Sort alphabetically by name
const sortedCities = uniqueCities.sort((a, b) => a.name.localeCompare(b.name));

    return (
        <div>
            <BreadcrumbComponent home='Home' listOne="Events" />
        <div className={Style.eventSec + ' ' + Style.componentsSpace + ' ' + Style.pageHideComp}>
            <Container>
                <Row>
                    <Col md={12}>
                        <div className={Style.sectionTitle}>
                            <h2>Events</h2>
                        </div>
                    </Col>
                    <Col md={12} className={Style.searchArea}>
                        <div className={Style.searchContainer}>
                            <div className={Style.searchInput}>
                                <input type="text" value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                                <button type="button" onClick={handleSearch}>Search</button>
                            </div>
                            <div className={Style.byYear}>
                                <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
                                    <option value="">Year</option>
                                    {years.map(year => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </select>
                                <select value={selectedCity} onChange={(e) => setSelectedCity(e.target.value)}>
                                    <option value="">City</option>
                                    {sortedCities.map(city => (
                                        <option key={city._id} value={city.name}>
                                            {city.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    {lastElement &&
                        (
                            <Col>
                                <div className={Style.eventContainer}>
                                    <div className={Style.eventElement}>
                                        <div className={Style.eventImg}>
                                            <img src={`${constants.IMAGE_BASE_URL}event/thumb/${encodeURIComponent(lastElement.image)}`}/>
                                            <Link to={`/event-detail/${lastElement.eventSlug}`} onClick={smoothScroll} className={Style.eventTag + ' ' + Button.brownBtn}>{lastElement.title}</Link>
                                        </div>
                                        <div className={Style.eventDetail}>
                                            <h3>{dateFormat(lastElement.eventDate, "dd mmmm yyyy | dddd")}</h3>
                                            <h4><Link to={`/event-detail/${lastElement.eventSlug}`} onClick={smoothScroll}>{lastElement.title}</Link></h4>
                                            <p className={Style.clampText}>{parse(`${lastElement.description}`)}</p>
                                            <ul>
                                                <li><MdLocationPin className={Style.eventIcon} /> {lastElement.address}, {lastElement.state.name}</li>
                                                <li>
                                                    {lastElement.startTime && lastElement.endTime === "null" ? null :
                                                        <><IoMdTime className={Style.eventIcon} /> {lastElement.startTime} - {lastElement.endTime}</>
                                                    }
                                                </li>
                                            </ul>
                                            {isAfterTargetDate ? (
                                                <Link to='/' onClick={smoothScroll} className={Button.greenBtn}>Registration Closed</Link>
                                            ) : (
                                                <Link to={`/event-detail/${lastElement.eventSlug}`} onClick={smoothScroll} className={Button.greenBtn}>Register</Link>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        )
                    }
                </Row>
                <>
                        {futureEventsData &&
                            futureEventsData.map((item, index)=>{
                                return(
                                    <div className={Style.FutureEvents}>
                                        <Row className={Style.rowSpace}>
                                            <Col md={12} className={Style.pageSubTitle}>
                                                <h3>Future Events</h3>
                                            </Col>
                                            <Col md={6} key={index} className={Style.futureWidth}>
                                                <div className={Style.eventContainer}>
                                                    <div className={Style.eventElement}>
                                                        <div className={Style.eventImg}>
                                                            <img src={`${constants.IMAGE_BASE_URL}event/thumb/${encodeURIComponent(item.image)}`}/>
                                                            <Link to={`/event-detail/${item.eventSlug}`} onClick={smoothScroll} className={Style.eventTag + ' ' + Button.brownBtn}>{item.title}</Link>
                                                        </div>
                                                        <div className={Style.eventDetail}>
                                                            <h3>{dateFormat(item.eventDate, "dd mmmm yyyy | dddd")}</h3>
                                                            <h4><Link to={`/event-detail/${item.eventSlug}`} onClick={smoothScroll}>{item.title}</Link></h4>
                                                            <p className={Style.clampText}>{parse(`${item.description}`)}</p>
                                                            <ul>
                                                                <li><MdLocationPin className={Style.eventIcon} /> {item.address}, {item.state.name}</li>
                                                                {item.startTime && item.endTime === "null" ? null :
                                                                    <><IoMdTime className={Style.eventIcon} /> {item.startTime} - {item.endTime}</>
                                                                }
                                                            </ul>
                                                            {isAfterTargetDate ? (
                                                                <Link to='/' onClick={smoothScroll} className={Button.greenBtn}>Registration Closed</Link>
                                                            ) : (
                                                                <Link to='/' onClick={smoothScroll} className={Button.greenBtn}>Register</Link>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                )
                            })
                        }
                </>
                <Row className={Style.rowSpace} ref={sectionPageingScroll}>
                    <Col md={12} className={Style.pageSubTitle}>
                        <h3>Past Events</h3>
                    </Col>
                    {postEventData && currentItems.length > 0 ?(
                        currentItems.map((value, i) => (
                        <Col md={4} key={i}>
                            <div className={Style.mediaList}>
                                <div className={Style.mediaImg}>
                                    
                                    {value.image !== "null" ?(
                                    <img src={`${constants.IMAGE_BASE_URL}event/thumb/${encodeURIComponent(value.image)}`} className={Style.coverImg} />    
                                    ):( <img src={require('../../assest/images/no-img.jpg')} className={Style.coverImg} />)}
                                    <Link to={`/event-detail/${value.eventSlug}`} onClick={smoothScroll} className={Style.eventTag + ' ' + Button.brownBtn}>{value.title}</Link>
                                </div>
                                <div className={Style.mediaDetail}>
                                    <h6>{dateFormat(value.eventDate, "dd mmmm yyyy ")}</h6>
                                    <h4><Link to={`/event-detail/${value.eventSlug}`} onClick={smoothScroll}>{value.title}</Link></h4>
                                    <Link to={`/event-detail/${value.eventSlug}`} onClick={smoothScroll}><IoArrowForwardCircleOutline className={Style.mediaLink} /></Link>
                                </div>
                            </div>
                        </Col>
                    ))
                    ) : (
                        <Col md={12} className={Style.noDataFound}>
                            <p>Data not found.</p>
                        </Col>
                    )}
                        {/* Pagination */}
                  {postEventData.length > itemsPerPage && (
                    
                            <div className={Button.flextCenterBtn + " " + Style.pagging}>
                                 <button onClick={goToFirstPage} disabled={currentPage === 1}>First</button>
                                <button onClick={goToPreviousPage} disabled={currentPage === 1}><GrFormPreviousLink  className={Style.lastIcon} /></button>
                                {Array.from({ length: totalPages }, (_, index) => index + 1).slice(Math.max(0, currentPage - 2), currentPage + 1).map((number) => (
                                    <button
                                        key={number}
                                        onClick={() => paginate(number)}
                                        className={currentPage === number ? Style.activePage : Style.inactivePage}
                                        
                                    >
                                        {number}
                                    </button>
                                ))}
                                <button onClick={goToNextPage} disabled={currentPage === totalPages}><GrFormNextLink className={Style.lastIcon} /> </button>
                                <button onClick={goToLastPage} disabled={currentPage === totalPages}>Last</button>
                            </div>
                      
                )}
                </Row>
              
                <Row>
                    <Col className={Style.pageLink}>
                        <div className={Button.flextCenterBtn + ' ' + Style.marginUp60}>
                            <Link to='/events' onClick={smoothScroll} className={Button.brownBorderBtn}>See All Events</Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
        </div>
    );
};

export default EventComponent;
